import { useContext } from 'react';

import { IntegrationContext } from '@contexts/integration-context';

export const useIntegrations = () => {
    const context = useContext(IntegrationContext);
    if (context === undefined) {
        throw new Error('useIntegrations must be used within an IntegrationProvider');
    }
    return context;
};